import React from "react";

export const DashboardIcon = () => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 15 16"
      fill="none"
    >
      <g id="IONIcon/H/home/default">
        <path
          id="Vector"
          d="M7.66289 3.4676C7.61927 3.42588 7.56124 3.40259 7.50088 3.40259C7.44052 3.40259 7.38248 3.42588 7.33887 3.4676L1.94531 8.62004C1.92241 8.64195 1.90418 8.66828 1.89175 8.69744C1.87931 8.72659 1.87291 8.75797 1.87295 8.78967L1.87207 13.6254C1.87207 13.874 1.97084 14.1125 2.14666 14.2883C2.32247 14.4641 2.56093 14.5629 2.80957 14.5629H5.625C5.74932 14.5629 5.86855 14.5135 5.95645 14.4256C6.04436 14.3377 6.09375 14.2185 6.09375 14.0942V10.1098C6.09375 10.0476 6.11844 9.98801 6.1624 9.94406C6.20635 9.9001 6.26596 9.87541 6.32812 9.87541H8.67187C8.73403 9.87541 8.79365 9.9001 8.8376 9.94406C8.88155 9.98801 8.90625 10.0476 8.90625 10.1098V14.0942C8.90625 14.2185 8.95563 14.3377 9.04354 14.4256C9.13145 14.5135 9.25068 14.5629 9.375 14.5629H12.1893C12.4379 14.5629 12.6764 14.4641 12.8522 14.2883C13.028 14.1125 13.1268 13.874 13.1268 13.6254V8.78967C13.1268 8.75797 13.1204 8.72659 13.108 8.69744C13.0955 8.66828 13.0773 8.64195 13.0544 8.62004L7.66289 3.4676Z"
          fill="#BBA383"
        />
        <path
          id="Vector_2"
          d="M14.3826 7.65381L12.1912 5.55732V2.37598C12.1912 2.25166 12.1418 2.13243 12.0539 2.04452C11.966 1.95661 11.8468 1.90723 11.7225 1.90723H10.3162C10.1919 1.90723 10.0727 1.95661 9.98476 2.04452C9.89685 2.13243 9.84747 2.25166 9.84747 2.37598V3.31348L8.15059 1.69102C7.9918 1.53047 7.75567 1.43848 7.5005 1.43848C7.2462 1.43848 7.01065 1.53047 6.85186 1.69131L0.620421 7.65322C0.438195 7.829 0.415343 8.11816 0.581163 8.30859C0.622803 8.35666 0.673789 8.39575 0.731016 8.42349C0.788244 8.45122 0.850517 8.46703 0.914046 8.46993C0.977575 8.47284 1.04103 8.46278 1.10055 8.44039C1.16007 8.41799 1.21441 8.38371 1.26026 8.33965L7.33936 2.53066C7.38298 2.48894 7.44102 2.46565 7.50138 2.46565C7.56174 2.46565 7.61977 2.48894 7.66339 2.53066L13.7431 8.33965C13.8326 8.42553 13.9526 8.4724 14.0766 8.46999C14.2007 8.46757 14.3187 8.41606 14.4049 8.32676C14.5848 8.14043 14.5698 7.83281 14.3826 7.65381Z"
          fill="#BBA383"
        />
      </g>
    </svg>
  </div>
);

export const UserIcon = () => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 15 16"
      fill="none"
    >
      <g id="IONIcon/P/person/default">
        <path
          id="Vector"
          d="M9.74522 2.39181C9.1751 1.77628 8.37881 1.43732 7.49991 1.43732C6.61631 1.43732 5.81739 1.77423 5.24991 2.38595C4.67627 3.00441 4.39678 3.84493 4.46241 4.75255C4.59248 6.54317 5.95508 7.99981 7.49991 7.99981C9.04473 7.99981 10.405 6.54347 10.5371 4.75314C10.6036 3.85372 10.3224 3.01495 9.74522 2.39181Z"
          fill="#BBA383"
        />
        <path
          id="Vector_2"
          d="M12.6562 14.5616H2.34367C2.20869 14.5634 2.07502 14.535 1.95237 14.4786C1.82973 14.4222 1.7212 14.3392 1.63469 14.2356C1.44426 14.0079 1.3675 13.6971 1.42434 13.3827C1.6716 12.0111 2.44328 10.8588 3.65617 10.0499C4.73371 9.33186 6.09865 8.93665 7.49992 8.93665C8.90119 8.93665 10.2661 9.33215 11.3437 10.0499C12.5566 10.8585 13.3282 12.0108 13.5755 13.3824C13.6323 13.6968 13.5556 14.0076 13.3652 14.2353C13.2787 14.339 13.1702 14.422 13.0475 14.4785C12.9249 14.535 12.7912 14.5634 12.6562 14.5616Z"
          fill="#BBA383"
        />
      </g>
    </svg>
  </div>
);

export const MembersIcon = () => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g id="mingcute:vip-2-fill" clipPath="url(#clip0_11_104)">
        <g id="Group">
          <path
            id="Vector"
            d="M9.15809 3.82667C9.41425 3.68137 9.61509 3.45535 9.72928 3.18389C9.84346 2.91243 9.86456 2.6108 9.78928 2.32609C9.714 2.04137 9.54657 1.78959 9.31314 1.61005C9.0797 1.4305 8.79339 1.33329 8.49889 1.33359C8.20439 1.33389 7.91828 1.43168 7.68521 1.6117C7.45214 1.79172 7.28522 2.04384 7.21052 2.3287C7.13582 2.61357 7.15753 2.91515 7.27226 3.18638C7.387 3.45761 7.5883 3.68322 7.84476 3.828L7.83809 3.84C7.40142 4.75134 6.79476 6.05667 5.85809 6.54667C5.08876 6.94867 3.98476 6.74667 3.16476 6.596C3.1516 6.40954 3.08645 6.2305 2.97669 6.0792C2.86694 5.92789 2.71697 5.81038 2.54381 5.73999C2.37064 5.6696 2.18122 5.64915 1.99702 5.68097C1.81283 5.71278 1.64124 5.79559 1.50172 5.91999C1.36221 6.04439 1.26035 6.2054 1.20771 6.38476C1.15507 6.56412 1.15375 6.75464 1.20391 6.93471C1.25407 7.11477 1.35369 7.27718 1.49147 7.40349C1.62926 7.52981 1.79969 7.61498 1.98342 7.64934L3.94876 12.7227C4.09451 13.0988 4.35058 13.422 4.68335 13.65C5.01613 13.878 5.41006 14 5.81342 14H11.1868C11.5901 14 11.9841 13.878 12.3168 13.65C12.6496 13.422 12.9057 13.0988 13.0514 12.7227L15.0161 7.64934C15.1987 7.61536 15.3682 7.5312 15.5056 7.40631C15.6431 7.28142 15.743 7.12071 15.7943 6.94221C15.8455 6.76371 15.8461 6.57446 15.7958 6.39567C15.7456 6.21688 15.6465 6.05562 15.5098 5.92995C15.3731 5.80428 15.204 5.71916 15.0217 5.68415C14.8393 5.64914 14.6507 5.66561 14.4772 5.73171C14.3036 5.79781 14.1519 5.91094 14.039 6.05841C13.9262 6.20588 13.8566 6.38188 13.8381 6.56667C12.9988 6.67534 11.9168 6.814 11.1421 6.40934C10.2241 5.92934 9.60876 4.714 9.15809 3.82667Z"
            fill="#BBA383"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_11_104">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export const BusinessIcon = () => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g id="ic:round-business-center">
        <path
          id="Vector"
          d="M9.16658 10.6667H7.83325C7.46659 10.6667 7.16658 10.3667 7.16658 10H2.50659V12.6667C2.50659 13.4 3.10659 14 3.83992 14H13.1666C13.8999 14 14.4999 13.4 14.4999 12.6667V10H9.83325C9.83325 10.3667 9.53325 10.6667 9.16658 10.6667ZM13.8333 4.66667H11.1666C11.1666 3.19333 9.97325 2 8.49992 2C7.02659 2 5.83325 3.19333 5.83325 4.66667H3.16659C2.43325 4.66667 1.83325 5.26667 1.83325 6V8C1.83325 8.74 2.42659 9.33333 3.16659 9.33333H7.16658V8.66667C7.16658 8.3 7.46659 8 7.83325 8H9.16658C9.53325 8 9.83325 8.3 9.83325 8.66667V9.33333H13.8333C14.5666 9.33333 15.1666 8.73333 15.1666 8V6C15.1666 5.26667 14.5666 4.66667 13.8333 4.66667ZM7.16658 4.66667C7.16658 3.93333 7.76658 3.33333 8.49992 3.33333C9.23325 3.33333 9.83325 3.93333 9.83325 4.66667H7.15992H7.16658Z"
          fill="#BBA383"
        />
      </g>
    </svg>
  </div>
);

export const BellIcon = () => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 17 16"
      fill="none"
    >
      <g id="fluent:speaker-edit-20-filled">
        <path
          id="Vector"
          d="M10.0993 2.4016C10.0993 1.7032 9.2673 1.34 8.7553 1.8152L5.6577 4.6904C5.58368 4.75888 5.48653 4.79689 5.3857 4.7968H3.3001C2.98184 4.7968 2.67661 4.92323 2.45157 5.14827C2.22653 5.37332 2.1001 5.67854 2.1001 5.9968V9.9976C2.1001 10.3159 2.22653 10.6211 2.45157 10.8461C2.67661 11.0712 2.98184 11.1976 3.3001 11.1976H5.3857C5.48664 11.1977 5.58381 11.236 5.6577 11.3048L7.9241 13.408L8.0457 12.9224C8.1577 12.4728 8.3905 12.0624 8.7177 11.7344L10.1001 10.352L10.0993 2.4016ZM13.2673 3.7296C14.1568 4.72158 14.7131 5.96746 14.8577 7.292C14.5926 7.21391 14.3157 7.1841 14.0401 7.204C13.8854 6.10996 13.409 5.08661 12.6713 4.264C12.6054 4.18438 12.5729 4.08235 12.5806 3.9793C12.5883 3.87625 12.6355 3.78017 12.7125 3.71118C12.7894 3.6422 12.8901 3.60568 12.9934 3.60926C13.0966 3.61284 13.1945 3.65625 13.2665 3.7304M12.3065 5.7984C12.6393 6.3744 12.8265 6.9952 12.8801 7.6176C12.7731 7.69349 12.6727 7.77833 12.5801 7.8712L12.0761 8.3744C12.1567 7.61838 11.9947 6.85633 11.6137 6.1984C11.5615 6.10658 11.5477 5.99783 11.5754 5.89589C11.6031 5.79396 11.6699 5.7071 11.7614 5.65429C11.8529 5.60148 11.9615 5.58699 12.0637 5.61398C12.1658 5.64098 12.2531 5.70728 12.3065 5.7984ZM9.2825 12.3008L13.1457 8.4368C13.2842 8.29614 13.4493 8.1843 13.6312 8.10772C13.8132 8.03115 14.0086 7.99135 14.206 7.99062C14.4034 7.98989 14.599 8.02825 14.7816 8.10349C14.9641 8.17872 15.1299 8.28934 15.2695 8.42898C15.4091 8.56861 15.5197 8.73449 15.5948 8.91705C15.67 9.09962 15.7083 9.29525 15.7075 9.49268C15.7067 9.69011 15.6668 9.88544 15.5902 10.0674C15.5135 10.2493 15.4016 10.4143 15.2609 10.5528L11.3977 14.4168C11.1726 14.642 10.8906 14.8018 10.5817 14.8792L9.3833 15.1792C9.26403 15.2088 9.13912 15.2071 9.02071 15.1742C8.90231 15.1412 8.79445 15.0782 8.70763 14.9912C8.62081 14.9042 8.55798 14.7963 8.52526 14.6778C8.49253 14.5593 8.49103 14.4344 8.5209 14.3152L8.8201 13.1176C8.8977 12.808 9.0569 12.5256 9.2825 12.3008Z"
          fill="#BBA383"
        />
      </g>
    </svg>
  </div>
);

export const SettingsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g id="IONIcon/S/settings/sharp" clipPath="url(#clip0_11_127)">
      <path
        id="Vector"
        d="M7.99994 5.49985C7.50549 5.49985 7.02214 5.64647 6.61102 5.92117C6.19989 6.19588 5.87946 6.58632 5.69024 7.04314C5.50102 7.49995 5.45152 8.00262 5.54798 8.48757C5.64444 8.97253 5.88254 9.41798 6.23217 9.76761C6.58181 10.1172 7.02726 10.3553 7.51222 10.4518C7.99717 10.5483 8.49984 10.4988 8.95665 10.3095C9.41347 10.1203 9.80391 9.79989 10.0786 9.38877C10.3533 8.97765 10.4999 8.4943 10.4999 7.99985C10.498 7.33741 10.2339 6.70268 9.76552 6.23427C9.29711 5.76585 8.66237 5.50183 7.99994 5.49985ZM13.3974 7.99985C13.3961 8.23345 13.379 8.46669 13.3462 8.69797L14.8678 9.88922C14.934 9.94394 14.9787 10.0204 14.9937 10.1051C15.0088 10.1897 14.9933 10.2769 14.9499 10.3511L13.5106 12.8361C13.4668 12.9097 13.3985 12.9654 13.3177 12.9936C13.2369 13.0218 13.1487 13.0206 13.0687 12.9902L11.2796 12.2714C10.9071 12.5583 10.4994 12.7964 10.0665 12.9798L9.799 14.8792C9.78403 14.9643 9.73998 15.0415 9.67437 15.0977C9.60877 15.1539 9.52568 15.1856 9.43932 15.1873H6.56057C6.47577 15.1857 6.39404 15.1553 6.32871 15.1013C6.26338 15.0472 6.21832 14.9725 6.20088 14.8895L5.93338 12.9902C5.49928 12.8088 5.0913 12.5703 4.72025 12.2811L2.93119 12.9998C2.85122 13.0303 2.76307 13.0316 2.68226 13.0034C2.60144 12.9753 2.53312 12.9196 2.48932 12.8461L1.04994 10.3614C1.00662 10.2872 0.991095 10.2 1.00615 10.1154C1.02121 10.0308 1.06586 9.95425 1.13213 9.89953L2.65369 8.70828C2.62124 8.4735 2.60412 8.23686 2.60244 7.99985C2.60374 7.76625 2.62087 7.53301 2.65369 7.30172L1.13213 6.11047C1.06586 6.05575 1.02121 5.97925 1.00615 5.89464C0.991095 5.81003 1.00662 5.72282 1.04994 5.6486L2.48932 3.1636C2.53307 3.09003 2.60137 3.03426 2.68219 3.00608C2.76301 2.9779 2.85118 2.97912 2.93119 3.00953L4.72025 3.72828C5.09279 3.44141 5.50047 3.20334 5.93338 3.01985L6.20088 1.12047C6.21585 1.03539 6.2599 0.958155 6.32551 0.901955C6.39111 0.845755 6.4742 0.814081 6.56057 0.812347H9.43932C9.52411 0.813998 9.60585 0.844345 9.67117 0.898434C9.7365 0.952523 9.78156 1.02716 9.799 1.11016L10.0665 3.00953C10.5012 3.19078 10.9097 3.42924 11.2812 3.7186L13.0687 2.99985C13.1487 2.96941 13.2368 2.96813 13.3176 2.99626C13.3984 3.02438 13.4668 3.08009 13.5106 3.1536L14.9499 5.6386C14.9933 5.71282 15.0088 5.80003 14.9937 5.88464C14.9787 5.96925 14.934 6.04575 14.8678 6.10047L13.3462 7.29172C13.3786 7.5264 13.3958 7.76294 13.3974 7.99985Z"
        fill="#D8E0E9"
      />
    </g>
    <defs>
      <clipPath id="clip0_11_127">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0 -0.000305176)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const NotificationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g id="IONIcon/N/notifications/default">
      <path
        id="Vector"
        d="M13.7526 10.6653C13.7007 10.6028 13.6498 10.5403 13.5998 10.48C12.9123 9.64845 12.4963 9.14657 12.4963 6.79251C12.4963 5.57376 12.2048 4.57376 11.6301 3.82376C11.2063 3.2697 10.6335 2.84939 9.87851 2.53876C9.86879 2.53336 9.86011 2.52627 9.85288 2.51783C9.58132 1.60845 8.83819 0.99939 8.00007 0.99939C7.16195 0.99939 6.41913 1.60845 6.14757 2.51689C6.14032 2.52502 6.13177 2.53189 6.12226 2.5372C4.36038 3.26251 3.50413 4.65408 3.50413 6.79157C3.50413 9.14657 3.08882 9.64845 2.4007 10.4791C2.3507 10.5394 2.29976 10.6006 2.24789 10.6644C2.11389 10.826 2.02899 11.0226 2.00323 11.2309C1.97748 11.4393 2.01195 11.6506 2.10257 11.84C2.29539 12.2463 2.70632 12.4984 3.17538 12.4984H12.8282C13.2951 12.4984 13.7032 12.2466 13.8966 11.8422C13.9876 11.6528 14.0224 11.4413 13.9969 11.2327C13.9714 11.0241 13.8866 10.8272 13.7526 10.6653Z"
        fill="#D8E0E9"
      />
      <path
        id="Vector_2"
        d="M7.99998 14.9997C8.45156 14.9993 8.89461 14.8767 9.28216 14.6449C9.66971 14.4131 9.98729 14.0808 10.2012 13.6831C10.2113 13.664 10.2163 13.6427 10.2157 13.6212C10.2151 13.5996 10.2089 13.5786 10.1978 13.5601C10.1866 13.5416 10.1709 13.5264 10.1521 13.5158C10.1334 13.5052 10.1122 13.4996 10.0906 13.4997H5.90998C5.8884 13.4996 5.86716 13.5051 5.84834 13.5157C5.82952 13.5262 5.81376 13.5415 5.80259 13.56C5.79141 13.5784 5.78522 13.5995 5.7846 13.6211C5.78398 13.6427 5.78896 13.664 5.79905 13.6831C6.01296 14.0807 6.3305 14.4131 6.71799 14.6449C7.10547 14.8766 7.54846 14.9992 7.99998 14.9997Z"
        fill="#D8E0E9"
      />
    </g>
  </svg>
);

export const UsersIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g id="IONIcon/P/person/default">
      <path
        id="Vector"
        d="M10.3949 2.01758C9.78678 1.36101 8.93741 0.999451 7.99991 0.999451C7.05741 0.999451 6.20522 1.35883 5.59991 2.01133C4.98803 2.67101 4.68991 3.56757 4.75991 4.5357C4.89866 6.4457 6.3521 7.99945 7.99991 7.99945C9.64772 7.99945 11.0987 6.44601 11.2396 4.53632C11.3105 3.57695 11.0105 2.68226 10.3949 2.01758Z"
        fill="#D8E0E9"
      />
      <path
        id="Vector_2"
        d="M13.4999 14.9987H2.49993C2.35595 15.0006 2.21337 14.9704 2.08255 14.9102C1.95173 14.85 1.83597 14.7615 1.74368 14.6509C1.54056 14.4081 1.45868 14.0766 1.51931 13.7412C1.78306 12.2781 2.60618 11.0491 3.89993 10.1862C5.04931 9.42031 6.50524 8.99875 7.99993 8.99875C9.49462 8.99875 10.9506 9.42062 12.0999 10.1862C13.3937 11.0487 14.2168 12.2778 14.4806 13.7409C14.5412 14.0762 14.4593 14.4078 14.2562 14.6506C14.1639 14.7612 14.0482 14.8498 13.9174 14.9101C13.7865 14.9703 13.6439 15.0006 13.4999 14.9987Z"
        fill="#D8E0E9"
      />
    </g>
  </svg>
);

export const ArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <path
      id="Vector"
      d="M1.23758 1.47923C1.15711 1.39876 1.09328 1.30322 1.04973 1.19809C1.00618 1.09295 0.983765 0.980261 0.983765 0.86646C0.983765 0.752658 1.00618 0.639972 1.04973 0.534833C1.09328 0.429695 1.15711 0.334163 1.23758 0.253694C1.31805 0.173224 1.41358 0.109392 1.51872 0.0658426C1.62386 0.0222928 1.73654 -0.000122071 1.85035 -0.00012207C1.96415 -0.000122069 2.07683 0.0222928 2.18197 0.0658426C2.28711 0.109392 2.38264 0.173224 2.46311 0.253694L8.52153 6.31211C8.60213 6.39251 8.66608 6.48802 8.70971 6.59316C8.75334 6.69831 8.7758 6.81104 8.7758 6.92488C8.7758 7.03872 8.75334 7.15144 8.70971 7.25659C8.66608 7.36174 8.60213 7.45725 8.52153 7.53764L2.46311 13.5961C2.38264 13.6765 2.28711 13.7404 2.18197 13.7839C2.07683 13.8275 1.96415 13.8499 1.85035 13.8499C1.73654 13.8499 1.62386 13.8275 1.51872 13.7839C1.41358 13.7404 1.31805 13.6765 1.23758 13.5961C1.15711 13.5156 1.09328 13.4201 1.04973 13.3149C1.00618 13.2098 0.983765 13.0971 0.983765 12.9833C0.983765 12.8695 1.00618 12.7568 1.04973 12.6517C1.09328 12.5465 1.15711 12.451 1.23758 12.3705L6.68496 6.92488L1.23758 1.47923ZM13.9672 0.86646C13.9672 0.636918 13.876 0.416778 13.7137 0.254467C13.5514 0.0921565 13.3312 0.000971164 13.1017 0.000971164C12.8722 0.000971164 12.652 0.0921565 12.4897 0.254467C12.3274 0.416778 12.2362 0.636918 12.2362 0.86646V12.9833C12.2362 13.2128 12.3274 13.433 12.4897 13.5953C12.652 13.7576 12.8722 13.8488 13.1017 13.8488C13.3312 13.8488 13.5514 13.7576 13.7137 13.5953C13.876 13.433 13.9672 13.2128 13.9672 12.9833V0.86646Z"
      fill="white"
    />
  </svg>
);

export const NextArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="14"
    viewBox="0 0 9 14"
    fill="none"
  >
    <g id="Group 75956">
      <path
        id="Form 3"
        d="M6.46334 7.08374L1.27234 1.85474C1.08743 1.66869 0.983643 1.41709 0.983643 1.15479C0.983643 0.892481 1.08743 0.640758 1.27234 0.454712C1.36309 0.36307 1.4711 0.290369 1.59013 0.240723C1.70917 0.191076 1.83686 0.165527 1.96584 0.165527C2.09481 0.165527 2.2225 0.191076 2.34154 0.240723C2.46057 0.290369 2.56859 0.36307 2.65934 0.454712L8.54433 6.38281C8.72924 6.56886 8.83303 6.82046 8.83303 7.08276C8.83303 7.34507 8.72924 7.59667 8.54433 7.78271L2.65934 13.7108C2.56859 13.8025 2.46057 13.8752 2.34154 13.9248C2.2225 13.9745 2.09481 14 1.96584 14C1.83686 14 1.70917 13.9745 1.59013 13.9248C1.4711 13.8752 1.36309 13.8025 1.27234 13.7108C1.08767 13.5246 0.984055 13.273 0.984055 13.0107C0.984055 12.7485 1.08767 12.497 1.27234 12.3108L6.46334 7.08374Z"
        fill="white"
      />
    </g>
  </svg>
);

export const PrevIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
  >
    <path
      id="Vector"
      d="M12.7296 12.3706C12.8101 12.4511 12.8739 12.5466 12.9174 12.6518C12.961 12.7569 12.9834 12.8696 12.9834 12.9834C12.9834 13.0972 12.961 13.2099 12.9174 13.315C12.8739 13.4202 12.8101 13.5157 12.7296 13.5962C12.6491 13.6766 12.5536 13.7405 12.4484 13.784C12.3433 13.8276 12.2306 13.85 12.1168 13.85C12.003 13.85 11.8903 13.8276 11.7852 13.784C11.6801 13.7405 11.5845 13.6766 11.5041 13.5962L5.44563 7.53774C5.36503 7.45734 5.30109 7.36184 5.25745 7.25669C5.21382 7.15154 5.19137 7.03882 5.19137 6.92498C5.19137 6.81113 5.21382 6.69841 5.25745 6.59326C5.30109 6.48811 5.36503 6.39261 5.44563 6.31221L11.5041 0.253791C11.5845 0.173321 11.6801 0.109489 11.7852 0.0659389C11.8903 0.0223894 12.003 -2.47955e-05 12.1168 -2.47955e-05C12.2306 -2.47955e-05 12.3433 0.0223894 12.4484 0.0659389C12.5536 0.109489 12.6491 0.173321 12.7296 0.253791C12.8101 0.33426 12.8739 0.429791 12.9174 0.53493C12.961 0.640068 12.9834 0.752755 12.9834 0.866556C12.9834 0.980358 12.961 1.09305 12.9174 1.19818C12.8739 1.30332 12.8101 1.39885 12.7296 1.47932L7.2822 6.92498L12.7296 12.3706ZM-1.71661e-05 12.9834C-1.71661e-05 13.2129 0.0911674 13.4331 0.253478 13.5954C0.415789 13.7577 0.635929 13.8489 0.865471 13.8489C1.09501 13.8489 1.31515 13.7577 1.47746 13.5954C1.63978 13.4331 1.73096 13.2129 1.73096 12.9834L1.73096 0.866556C1.73096 0.637014 1.63978 0.416874 1.47746 0.254563C1.31515 0.0922527 1.09501 0.00106812 0.865471 0.00106812C0.635929 0.00106812 0.415789 0.0922527 0.253478 0.254563C0.0911674 0.416874 -1.71661e-05 0.637014 -1.71661e-05 0.866556L-1.71661e-05 12.9834Z"
      fill="white"
    />
  </svg>
);

export const ArrowNext = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="14"
    viewBox="0 0 8 14"
    fill="none"
  >
    <path
      id="Form 4"
      d="M2.5037 6.91614L7.6947 12.1451C7.87961 12.3312 7.9834 12.5828 7.9834 12.8451C7.9834 13.1074 7.87961 13.3591 7.6947 13.5452C7.60395 13.6368 7.49594 13.7095 7.37691 13.7592C7.25787 13.8088 7.13018 13.8344 7.00121 13.8344C6.87223 13.8344 6.74454 13.8088 6.6255 13.7592C6.50647 13.7095 6.39845 13.6368 6.3077 13.5452L0.422707 7.61707C0.237799 7.43102 0.13401 7.17942 0.13401 6.91711C0.13401 6.65481 0.237799 6.40321 0.422707 6.21716L6.3077 0.289063C6.39845 0.197421 6.50647 0.12472 6.6255 0.0750732C6.74454 0.0254266 6.87223 -0.00012207 7.00121 -0.00012207C7.13018 -0.00012207 7.25787 0.0254266 7.37691 0.0750732C7.49594 0.12472 7.60395 0.197421 7.6947 0.289062C7.87937 0.475236 7.98299 0.726911 7.98299 0.989136C7.98299 1.25136 7.87937 1.50291 7.6947 1.68909L2.5037 6.91614Z"
      fill="white"
    />
  </svg>
);

export const ExitIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
  >
    <g id="Group 75975">
      <g id="Ellipse 80" filter="url(#filter0_b_33_8894)">
        <circle cx="21" cy="21" r="21" fill="#121212" fillOpacity="0.7" />
      </g>
      <g id="Vector">
        <path
          d="M12.2982 29.2312C11.9006 28.8414 11.9006 28.2094 12.2982 27.8196L28.1365 12.2923C28.5341 11.9026 29.1788 11.9026 29.5764 12.2923C29.974 12.6821 29.974 13.3141 29.5764 13.7039L13.7381 29.2312C13.3404 29.621 12.6958 29.621 12.2982 29.2312Z"
          fill="white"
        />
        <path
          d="M29.7018 29.7077C29.3042 30.0974 28.6596 30.0974 28.262 29.7077L12.4236 14.1804C12.026 13.7906 12.026 13.1586 12.4236 12.7688C12.8212 12.379 13.4659 12.379 13.8635 12.7688L29.7018 28.2961C30.0994 28.6859 30.0994 29.3179 29.7018 29.7077Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_b_33_8894"
        x="-80"
        y="-80"
        width="202"
        height="202"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="40" />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_33_8894"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_33_8894"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const CampaignIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="120"
    height="18"
    viewBox="0 0 120 18"
    fill="none"
  >
    <g id="Pendulum-Wordmark-Black 1" clipPath="url(#clip0_33_8885)">
      <g id="Vector" filter="url(#filter0_d_33_8885)">
        <path
          d="M10.2478 0.937988C10.4782 0.937988 10.6164 1.07763 10.6164 1.31035V2.70671C10.6164 2.93944 10.7547 3.07908 10.9851 3.07908H12.3675C12.5979 3.07908 12.7361 3.21872 12.7361 3.45144V7.52418C12.7361 7.75686 12.5979 7.8965 12.3675 7.8965H10.9851C10.7547 7.8965 10.6164 8.03614 10.6164 8.26888V9.66525C10.6164 9.898 10.4782 10.0376 10.2478 10.0376H2.50639C2.27599 10.0376 2.13775 10.1773 2.13775 10.41V17.1823C2.13775 17.4151 1.99951 17.5547 1.76911 17.5547H0.386707C0.156307 17.5547 0.0180664 17.4151 0.0180664 17.1823V1.31035C0.0180664 1.07763 0.156307 0.937988 0.386707 0.937988H10.2478ZM2.13775 7.52418C2.13775 7.75686 2.27599 7.8965 2.50639 7.8965H10.2478C10.4782 7.8965 10.6164 7.75686 10.6164 7.52418V3.45144C10.6164 3.21872 10.4782 3.07908 10.2478 3.07908H2.50639C2.27599 3.07908 2.13775 3.21872 2.13775 3.45144V7.52418Z"
          fill="white"
        />
      </g>
      <g id="Vector_2" filter="url(#filter1_d_33_8885)">
        <path
          d="M14.8452 17.5547V0.937988H26.2039V2.79981H17.034V8.08273H25.5819V9.94452H17.034V15.6929H26.2731V17.5547H14.8452Z"
          fill="white"
        />
      </g>
      <g id="Vector_3" filter="url(#filter2_d_33_8885)">
        <path
          d="M28.3315 17.5547V0.937988H30.6586L39.3217 14.4129H39.3677V0.937988H41.4413V17.5547H39.0451L30.4512 4.21944H30.4051V17.5547H28.3315Z"
          fill="white"
        />
      </g>
      <g id="Vector_4" filter="url(#filter3_d_33_8885)">
        <path
          d="M54.2156 0.937988C54.446 0.937988 54.5842 1.07763 54.5842 1.31035V2.70671C54.5842 2.93944 54.7225 3.07908 54.9529 3.07908H56.3353C56.5656 3.07908 56.7039 3.21872 56.7039 3.45144V15.0412C56.7039 15.274 56.5656 15.4136 56.3353 15.4136H54.9529C54.7225 15.4136 54.5842 15.5533 54.5842 15.786V17.1823C54.5842 17.4151 54.446 17.5547 54.2156 17.5547H44.3545C44.124 17.5547 43.9858 17.4151 43.9858 17.1823V1.31035C43.9858 1.07763 44.124 0.937988 44.3545 0.937988H54.2156ZM46.1055 15.0412C46.1055 15.274 46.2437 15.4136 46.4741 15.4136H54.2156C54.446 15.4136 54.5842 15.274 54.5842 15.0412V3.45144C54.5842 3.21872 54.446 3.07908 54.2156 3.07908H46.4741C46.2437 3.07908 46.1055 3.21872 46.1055 3.45144V15.0412Z"
          fill="white"
        />
      </g>
      <g id="Vector_5" filter="url(#filter4_d_33_8885)">
        <path
          d="M72.5382 0.937988V11.5503C72.5382 15.7394 70.165 17.9504 66.0634 17.9504C61.8243 17.9504 59.313 15.9722 59.313 11.5503V0.937988H61.5017V11.5503C61.5017 14.4827 63.1606 16.0885 66.0634 16.0885C68.8287 16.0885 70.3489 14.4827 70.3489 11.5503V0.937988H72.5382Z"
          fill="white"
        />
      </g>
      <g id="Vector_6" filter="url(#filter5_d_33_8885)">
        <path
          d="M74.7803 17.5547V0.937988H76.969V15.6929H85.6781V17.5547H74.7803Z"
          fill="white"
        />
      </g>
      <g id="Vector_7" filter="url(#filter6_d_33_8885)">
        <path
          d="M89.8971 0.937988C90.1273 0.937988 90.2656 1.07763 90.2656 1.31035V15.0412C90.2656 15.274 90.4038 15.4136 90.634 15.4136H98.376C98.6062 15.4136 98.7445 15.274 98.7445 15.0412V1.31035C98.7445 1.07763 98.8827 0.937988 99.113 0.937988H100.496C100.726 0.937988 100.864 1.07763 100.864 1.31035V15.0412C100.864 15.274 100.726 15.4136 100.496 15.4136H99.113C98.8827 15.4136 98.7445 15.5533 98.7445 15.786V17.1823C98.7445 17.4151 98.6062 17.5547 98.376 17.5547H90.634C90.4038 17.5547 90.2656 17.4151 90.2656 17.1823V15.786C90.2656 15.5533 90.1273 15.4136 89.8971 15.4136H88.5145C88.2843 15.4136 88.146 15.274 88.146 15.0412V1.31035C88.146 1.07763 88.2843 0.937988 88.5145 0.937988H89.8971Z"
          fill="white"
        />
      </g>
      <g id="Vector_8" filter="url(#filter7_d_33_8885)">
        <path
          d="M103.52 17.5547V0.937988H106.515L111.699 14.9016L116.906 0.937988H119.901V17.5547H117.828V3.73071H117.781L112.643 17.5547H110.778L105.64 3.73071H105.593V17.5547H103.52Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_33_8885"
        x="-3.98193"
        y="0.937988"
        width="20.7183"
        height="24.6167"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_33_8885"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_33_8885"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_33_8885"
        x="10.8452"
        y="0.937988"
        width="19.4277"
        height="24.6167"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_33_8885"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_33_8885"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_33_8885"
        x="24.3315"
        y="0.937988"
        width="21.1099"
        height="24.6167"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_33_8885"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_33_8885"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_33_8885"
        x="39.9858"
        y="0.937988"
        width="20.7183"
        height="24.6167"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_33_8885"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_33_8885"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_33_8885"
        x="55.313"
        y="0.937988"
        width="21.2251"
        height="25.0125"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_33_8885"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_33_8885"
          result="shape"
        />
      </filter>
      <filter
        id="filter5_d_33_8885"
        x="70.7803"
        y="0.937988"
        width="18.8979"
        height="24.6167"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_33_8885"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_33_8885"
          result="shape"
        />
      </filter>
      <filter
        id="filter6_d_33_8885"
        x="84.146"
        y="0.937988"
        width="20.7183"
        height="24.6167"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_33_8885"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_33_8885"
          result="shape"
        />
      </filter>
      <filter
        id="filter7_d_33_8885"
        x="99.5195"
        y="0.937988"
        width="24.3818"
        height="24.6167"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.29 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_33_8885"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_33_8885"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_33_8885">
        <rect
          width="120"
          height="17.4545"
          fill="white"
          transform="translate(0 0.550049)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const calenderIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15.8334 3.33341H14.1667V2.50008C14.1667 2.27907 14.079 2.06711 13.9227 1.91083C13.7664 1.75455 13.5544 1.66675 13.3334 1.66675C13.1124 1.66675 12.9004 1.75455 12.7442 1.91083C12.5879 2.06711 12.5001 2.27907 12.5001 2.50008V3.33341H7.50008V2.50008C7.50008 2.27907 7.41228 2.06711 7.256 1.91083C7.09972 1.75455 6.88776 1.66675 6.66675 1.66675C6.44573 1.66675 6.23377 1.75455 6.07749 1.91083C5.92121 2.06711 5.83341 2.27907 5.83341 2.50008V3.33341H4.16675C3.50371 3.33341 2.86782 3.59681 2.39898 4.06565C1.93014 4.53449 1.66675 5.17037 1.66675 5.83341V15.8334C1.66675 16.4965 1.93014 17.1323 2.39898 17.6012C2.86782 18.07 3.50371 18.3334 4.16675 18.3334H15.8334C16.4965 18.3334 17.1323 18.07 17.6012 17.6012C18.07 17.1323 18.3334 16.4965 18.3334 15.8334V5.83341C18.3334 5.17037 18.07 4.53449 17.6012 4.06565C17.1323 3.59681 16.4965 3.33341 15.8334 3.33341ZM16.6667 15.8334C16.6667 16.0544 16.579 16.2664 16.4227 16.4227C16.2664 16.579 16.0544 16.6667 15.8334 16.6667H4.16675C3.94573 16.6667 3.73377 16.579 3.57749 16.4227C3.42121 16.2664 3.33341 16.0544 3.33341 15.8334V10.0001H16.6667V15.8334ZM16.6667 8.33341H3.33341V5.83341C3.33341 5.6124 3.42121 5.40044 3.57749 5.24416C3.73377 5.08788 3.94573 5.00008 4.16675 5.00008H5.83341V5.83341C5.83341 6.05443 5.92121 6.26639 6.07749 6.42267C6.23377 6.57895 6.44573 6.66675 6.66675 6.66675C6.88776 6.66675 7.09972 6.57895 7.256 6.42267C7.41228 6.26639 7.50008 6.05443 7.50008 5.83341V5.00008H12.5001V5.83341C12.5001 6.05443 12.5879 6.26639 12.7442 6.42267C12.9004 6.57895 13.1124 6.66675 13.3334 6.66675C13.5544 6.66675 13.7664 6.57895 13.9227 6.42267C14.079 6.26639 14.1667 6.05443 14.1667 5.83341V5.00008H15.8334C16.0544 5.00008 16.2664 5.08788 16.4227 5.24416C16.579 5.40044 16.6667 5.6124 16.6667 5.83341V8.33341Z"
      fill="#8E929A"
    />
  </svg>
);

export const timeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_36_11349)">
      <path
        d="M10.4167 6.04175C10.4167 5.87599 10.3509 5.71702 10.2337 5.59981C10.1165 5.4826 9.95751 5.41675 9.79175 5.41675C9.62599 5.41675 9.46702 5.4826 9.34981 5.59981C9.2326 5.71702 9.16675 5.87599 9.16675 6.04175V10.6251C9.16675 10.8501 9.28675 11.0567 9.48175 11.1676L12.3984 12.8342C12.542 12.9118 12.7102 12.9302 12.8671 12.8854C13.0241 12.8406 13.1573 12.7362 13.2382 12.5945C13.3192 12.4528 13.3415 12.2851 13.3005 12.1271C13.2594 11.9692 13.1582 11.8335 13.0184 11.7492L10.4167 10.2626V6.04175Z"
        fill="#8E929A"
      />
      <path
        d="M9.99992 0.833252C15.0624 0.833252 19.1666 4.93742 19.1666 9.99992C19.1666 15.0624 15.0624 19.1666 9.99992 19.1666C4.93742 19.1666 0.833252 15.0624 0.833252 9.99992C0.833252 4.93742 4.93742 0.833252 9.99992 0.833252ZM2.08325 9.99992C2.08325 12.0996 2.91733 14.1132 4.40199 15.5978C5.88665 17.0825 7.90029 17.9166 9.99992 17.9166C12.0996 17.9166 14.1132 17.0825 15.5978 15.5978C17.0825 14.1132 17.9166 12.0996 17.9166 9.99992C17.9166 7.90029 17.0825 5.88665 15.5978 4.40199C14.1132 2.91733 12.0996 2.08325 9.99992 2.08325C7.90029 2.08325 5.88665 2.91733 4.40199 4.40199C2.91733 5.88665 2.08325 7.90029 2.08325 9.99992Z"
        fill="#8E929A"
      />
    </g>
    <defs>
      <clipPath id="clip0_36_11349">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const searchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
  >
    <path
      d="M17.7607 16.4825L14.4212 13.17C15.7175 11.5537 16.3453 9.50215 16.1754 7.43721C16.0056 5.37227 15.051 3.45088 13.508 2.06813C11.965 0.685379 9.95088 -0.0536394 7.87974 0.00303437C5.8086 0.0597081 3.83789 0.907766 2.37283 2.37283C0.907766 3.83789 0.0597081 5.8086 0.00303437 7.87974C-0.0536394 9.95088 0.685379 11.965 2.06813 13.508C3.45088 15.051 5.37227 16.0056 7.43721 16.1754C9.50215 16.3453 11.5537 15.7175 13.17 14.4212L16.4825 17.7337C16.5662 17.8181 16.6658 17.8851 16.7755 17.9308C16.8852 17.9765 17.0028 18 17.1216 18C17.2405 18 17.3581 17.9765 17.4678 17.9308C17.5775 17.8851 17.6771 17.8181 17.7607 17.7337C17.923 17.5659 18.0137 17.3416 18.0137 17.1081C18.0137 16.8747 17.923 16.6504 17.7607 16.4825ZM8.12015 14.4212C6.87392 14.4212 5.65568 14.0516 4.61948 13.3593C3.58328 12.6669 2.77566 11.6828 2.29875 10.5315C1.82184 9.38009 1.69706 8.11316 1.94018 6.89088C2.18331 5.6686 2.78343 4.54586 3.66464 3.66464C4.54586 2.78343 5.6686 2.18331 6.89088 1.94018C8.11316 1.69706 9.38009 1.82184 10.5315 2.29875C11.6828 2.77566 12.6669 3.58328 13.3593 4.61948C14.0516 5.65568 14.4212 6.87392 14.4212 8.12015C14.4212 9.79129 13.7573 11.394 12.5757 12.5757C11.394 13.7573 9.79129 14.4212 8.12015 14.4212Z"
      fill="#8E929A"
    />
  </svg>
);

export const AddIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M18 12.998H13V17.998C13 18.2633 12.8946 18.5176 12.7071 18.7052C12.5196 18.8927 12.2652 18.998 12 18.998C11.7348 18.998 11.4804 18.8927 11.2929 18.7052C11.1054 18.5176 11 18.2633 11 17.998V12.998H6C5.73478 12.998 5.48043 12.8927 5.29289 12.7052C5.10536 12.5176 5 12.2633 5 11.998C5 11.7328 5.10536 11.4785 5.29289 11.2909C5.48043 11.1034 5.73478 10.998 6 10.998H11V5.99805C11 5.73283 11.1054 5.47848 11.2929 5.29094C11.4804 5.1034 11.7348 4.99805 12 4.99805C12.2652 4.99805 12.5196 5.1034 12.7071 5.29094C12.8946 5.47848 13 5.73283 13 5.99805V10.998H18C18.2652 10.998 18.5196 11.1034 18.7071 11.2909C18.8946 11.4785 19 11.7328 19 11.998C19 12.2633 18.8946 12.5176 18.7071 12.7052C18.5196 12.8927 18.2652 12.998 18 12.998Z"
      fill="white"
    />
  </svg>
);
export const Line = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="2"
    viewBox="0 0 708 2"
    fill="none"
  >
    <path
      d="M1 1H707"
      stroke="#272B33"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 17 18"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.91944 5.51547C3.08026 5.50466 3.23874 5.55891 3.36005 5.66629C3.48137 5.77367 3.55559 5.9254 3.56641 6.08814L3.93936 11.7492C4.01232 12.8543 4.06421 13.6239 4.17772 14.2023C4.28879 14.7643 4.44283 15.0613 4.66416 15.2713C4.88631 15.4814 5.18953 15.6176 5.75056 15.6914C6.32943 15.7677 7.09153 15.7693 8.18604 15.7693H8.81356C9.90806 15.7693 10.6702 15.7677 11.249 15.6914C11.8101 15.6176 12.1133 15.4814 12.3354 15.2713C12.5568 15.0613 12.7108 14.7643 12.8219 14.2031C12.9354 13.6239 12.9873 12.8543 13.0602 11.7484L13.4332 6.08814C13.4385 6.00749 13.4595 5.9287 13.4949 5.85625C13.5303 5.78381 13.5795 5.71913 13.6396 5.66592C13.6997 5.6127 13.7696 5.57199 13.8452 5.54611C13.9209 5.52022 14.0009 5.50967 14.0806 5.51506C14.1603 5.52045 14.2381 5.54166 14.3097 5.5775C14.3813 5.61334 14.4452 5.6631 14.4978 5.72393C14.5504 5.78477 14.5906 5.85548 14.6162 5.93205C14.6418 6.00862 14.6522 6.08954 14.6469 6.17018L14.2707 11.8739C14.2018 12.9257 14.1458 13.7765 14.0145 14.4435C13.8775 15.1368 13.6456 15.716 13.1656 16.1697C12.6865 16.6242 12.0995 16.8203 11.4063 16.9114C10.7399 17 9.89833 17 8.85652 17H8.14307C7.10126 17 6.25971 17 5.59328 16.9114C4.90009 16.8203 4.31311 16.6242 3.83396 16.1697C3.354 15.716 3.12213 15.136 2.98511 14.4435C2.85377 13.7757 2.79864 12.9257 2.72891 11.8739L2.35273 6.17018C2.34744 6.08953 2.35791 6.00862 2.38353 5.93207C2.40916 5.85552 2.44943 5.78482 2.50206 5.72402C2.55468 5.66322 2.61863 5.61351 2.69025 5.57773C2.76186 5.54194 2.83974 5.52079 2.91944 5.51547ZM7.16612 1.0014H7.12883C6.95371 1.0014 6.80048 1.0014 6.65616 1.02438C6.37507 1.06994 6.10841 1.18146 5.87753 1.34999C5.64665 1.51853 5.45796 1.73941 5.32654 1.99496C5.25844 2.12623 5.2106 2.27309 5.15547 2.44128L5.14331 2.47738L5.06467 2.7153C5.00258 2.9386 4.86753 3.13399 4.68155 3.26959C4.49557 3.4052 4.26966 3.47299 4.0407 3.46191H1.60846C1.44709 3.46191 1.29232 3.52678 1.17821 3.64225C1.06411 3.75773 1 3.91434 1 4.07765C1 4.24095 1.06411 4.39757 1.17821 4.51304C1.29232 4.62851 1.44709 4.69339 1.60846 4.69339H15.3919C15.5532 4.69339 15.7079 4.62856 15.8219 4.51316C15.9359 4.39776 16 4.24125 16 4.07806C16 3.91486 15.9359 3.75835 15.8219 3.64295C15.7079 3.52755 15.5532 3.46273 15.3919 3.46273H12.8859C12.6694 3.45747 12.4602 3.38213 12.289 3.24777C12.1179 3.11341 11.9938 2.92708 11.9349 2.71612L11.8563 2.47738L11.8449 2.44128C11.789 2.27309 11.7412 2.12623 11.6739 1.99496C11.5424 1.73931 11.3535 1.51836 11.1225 1.34982C10.8915 1.18128 10.6247 1.06983 10.3434 1.02438C10.1867 1.00425 10.0287 0.996565 9.87077 1.0014H7.16612ZM6.18512 3.20429C6.15269 3.29371 6.11621 3.37986 6.07405 3.46273H10.9255C10.8836 3.37924 10.8467 3.2932 10.8153 3.20511L10.7829 3.11158L10.7026 2.86544C10.6729 2.76262 10.6369 2.66178 10.5948 2.56352C10.551 2.4782 10.4881 2.40445 10.4111 2.34817C10.3341 2.29189 10.2451 2.25466 10.1513 2.23945C10.0456 2.23023 9.93946 2.22777 9.83347 2.23206H7.16612C6.93263 2.23206 6.88398 2.2337 6.84831 2.24027C6.75459 2.25539 6.66567 2.2925 6.58866 2.34863C6.51165 2.40476 6.4487 2.47836 6.40483 2.56352C6.38862 2.59634 6.37078 2.64146 6.297 2.86626L6.21593 3.1124L6.18512 3.20429Z"
      fill="white"
      stroke="white"
      strokeWidth="0.25"
    />
  </svg>
);

export const ImageIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M20.25 3.9375H3.75C3.4019 3.9375 3.06806 4.07578 2.82192 4.32192C2.57578 4.56806 2.4375 4.9019 2.4375 5.25V18.75C2.4375 19.0981 2.57578 19.4319 2.82192 19.6781C3.06806 19.9242 3.4019 20.0625 3.75 20.0625H20.25C20.5981 20.0625 20.9319 19.9242 21.1781 19.6781C21.4242 19.4319 21.5625 19.0981 21.5625 18.75V5.25C21.5625 4.9019 21.4242 4.56806 21.1781 4.32192C20.9319 4.07578 20.5981 3.9375 20.25 3.9375ZM3.75 5.0625H20.25C20.2997 5.0625 20.3474 5.08225 20.3826 5.11742C20.4177 5.15258 20.4375 5.20027 20.4375 5.25V15.3347L17.6747 12.5719C17.5528 12.45 17.4081 12.3533 17.2489 12.2873C17.0896 12.2214 16.9189 12.1874 16.7466 12.1874C16.5742 12.1874 16.4035 12.2214 16.2443 12.2873C16.085 12.3533 15.9403 12.45 15.8184 12.5719L13.8103 14.58L9.55313 10.3219C9.43125 10.2 9.28655 10.1033 9.1273 10.0373C8.96805 9.97136 8.79737 9.93741 8.625 9.93741C8.45263 9.93741 8.28195 9.97136 8.1227 10.0373C7.96345 10.1033 7.81875 10.2 7.69687 10.3219L3.5625 14.4562V5.25C3.5625 5.20027 3.58225 5.15258 3.61742 5.11742C3.65258 5.08225 3.70027 5.0625 3.75 5.0625ZM3.5625 18.75V16.0472L8.49188 11.1178C8.50931 11.1002 8.53004 11.0863 8.55289 11.0768C8.57574 11.0673 8.60025 11.0624 8.625 11.0624C8.64975 11.0624 8.67426 11.0673 8.69711 11.0768C8.71996 11.0863 8.74069 11.1002 8.75812 11.1178L16.5778 18.9375H3.75C3.70027 18.9375 3.65258 18.9177 3.61742 18.8826C3.58225 18.8474 3.5625 18.7997 3.5625 18.75ZM20.25 18.9375H18.1688L14.6063 15.375L16.6134 13.3669C16.6309 13.3494 16.6515 13.3356 16.6743 13.3262C16.6971 13.3167 16.7215 13.3119 16.7461 13.3119C16.7707 13.3119 16.7951 13.3167 16.8179 13.3262C16.8407 13.3356 16.8613 13.3494 16.8787 13.3669L20.4412 16.9294V18.75C20.4413 18.7749 20.4363 18.7996 20.4266 18.8226C20.417 18.8456 20.4028 18.8665 20.385 18.8839C20.3672 18.9014 20.3461 18.9151 20.3229 18.9243C20.2997 18.9335 20.2749 18.938 20.25 18.9375ZM13.6875 9.375C13.6875 9.18958 13.7425 9.00832 13.8455 8.85415C13.9485 8.69998 14.0949 8.57982 14.2662 8.50886C14.4375 8.43791 14.626 8.41934 14.8079 8.45551C14.9898 8.49169 15.1568 8.58098 15.2879 8.71209C15.419 8.8432 15.5083 9.01025 15.5445 9.1921C15.5807 9.37396 15.5621 9.56246 15.4911 9.73377C15.4202 9.90507 15.3 10.0515 15.1458 10.1545C14.9917 10.2575 14.8104 10.3125 14.625 10.3125C14.3764 10.3125 14.1379 10.2137 13.9621 10.0379C13.7863 9.8621 13.6875 9.62364 13.6875 9.375Z"
      fill="white"
    />
  </svg>
);

export const ArrowDown = () => (
  <svg
    width="14"
    height="9"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99887 6.98105L14.0464 0.367795C14.2615 0.132225 14.5525 0 14.8559 0C15.1593 0 15.4504 0.132225 15.6655 0.367795C15.7715 0.48341 15.8556 0.621012 15.913 0.77266C15.9705 0.924308 16 1.08699 16 1.2513C16 1.41561 15.9705 1.57829 15.913 1.72994C15.8556 1.88159 15.7715 2.0192 15.6655 2.13481L8.80951 9.63221C8.59435 9.86777 8.30336 10 8 10C7.69664 10 7.40565 9.86777 7.19048 9.63221L0.334451 2.13481C0.228464 2.0192 0.144384 1.88159 0.0869657 1.72994C0.0295478 1.57829 0 1.41561 0 1.2513C0 1.08699 0.0295478 0.924308 0.0869657 0.77266C0.144384 0.621012 0.228464 0.48341 0.334451 0.367795C0.549766 0.132534 0.840836 0.000524866 1.14411 0.000524866C1.44738 0.000524866 1.73831 0.132534 1.95362 0.367795L7.99887 6.98105Z"
      fill="#8E929A"
    />
  </svg>
);

export const DownloadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 20C9.87827 20 7.84344 19.1571 6.34315 17.6569C4.84285 16.1566 4 14.1217 4 12M20 12C20.0011 13.1994 19.7319 14.3837 19.2126 15.4648C18.6932 16.546 17.937 17.4962 17 18.245"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M12 14V4M12 4L15 7M12 4L9 7"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RefreshIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="24"
    height="24"
    viewBox="0,0,256,256"
  >
    <g
      fill="#ffffff"
      fillRule="nonzero"
      stroke="none"
      strokeWidth="1"
      strokeLinecap="butt"
      strokeLinejoin="miter"
      strokeMiterlimit="10"
      strokeDasharray=""
      strokeDashoffset="0"
      fontFamily="none"
      fontWeight="none"
      fontSize="none"
      textAnchor="none"
    >
      <g transform="scale(8.53333,8.53333)">
        <path d="M15,3c-2.9686,0 -5.69718,1.08344 -7.79297,2.875c-0.28605,0.22772 -0.42503,0.59339 -0.36245,0.95363c0.06258,0.36023 0.31676,0.6576 0.66286,0.77549c0.3461,0.1179 0.72895,0.03753 0.99842,-0.20959c1.74821,-1.49444 4.01074,-2.39453 6.49414,-2.39453c5.19656,0 9.45099,3.93793 9.95117,9h-2.95117l4,6l4,-6h-3.05078c-0.51129,-6.14834 -5.67138,-11 -11.94922,-11zM4,10l-4,6h3.05078c0.51129,6.14834 5.67138,11 11.94922,11c2.9686,0 5.69718,-1.08344 7.79297,-2.875c0.28605,-0.22772 0.42504,-0.59339 0.36245,-0.95363c-0.06258,-0.36023 -0.31676,-0.6576 -0.66286,-0.7755c-0.3461,-0.1179 -0.72895,-0.03753 -0.99842,0.20959c-1.74821,1.49444 -4.01074,2.39453 -6.49414,2.39453c-5.19656,0 -9.45099,-3.93793 -9.95117,-9h2.95117z"></path>
      </g>
    </g>
  </svg>
);

export const BenefitsIcon = () => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <svg
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1669 7C12.0069 7 13.5003 5.50667 13.5003 3.66667C13.5003 1.82667 12.0069 0.333336 10.1669 0.333336C8.32692 0.333336 6.83358 1.82667 6.83358 3.66667C6.83358 5.50667 8.32692 7 10.1669 7ZM13.8003 10.7333C13.5403 10.4667 13.2136 10.3333 12.8336 10.3333H8.16692L6.78025 9.84667L7.00025 9.22L8.16692 9.66667H10.0336C10.2669 9.66667 10.4536 9.57334 10.6069 9.42C10.7603 9.26667 10.8336 9.08 10.8336 8.87334C10.8336 8.51334 10.6602 8.26667 10.3136 8.12667L5.46692 6.33334H4.16692V12.3333L8.83358 13.6667L14.1869 11.6667C14.1936 11.3133 14.0603 11 13.8003 10.7333ZM2.83358 6.33334H0.15625V13.6667H2.83358V6.33334Z"
        fill="#BBA383"
      />
    </svg>
  </div>
);

export const CancelIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.298202 17.2312C-0.0994008 16.8414 -0.0994007 16.2094 0.298202 15.8196L16.1365 0.292345C16.5341 -0.0974483 17.1788 -0.0974486 17.5764 0.292345C17.974 0.682139 17.974 1.31412 17.5764 1.70391L1.73805 17.2312C1.34045 17.621 0.695805 17.621 0.298202 17.2312Z"
      fill="white"
    />
    <path
      d="M17.7018 17.7077C17.3042 18.0974 16.6596 18.0974 16.262 17.7077L0.423623 2.18041C0.0260199 1.79061 0.0260196 1.15863 0.423623 0.768839C0.821226 0.379045 1.46587 0.379045 1.86347 0.768839L17.7018 16.2961C18.0994 16.6859 18.0994 17.3179 17.7018 17.7077Z"
      fill="white"
    />
  </svg>
);

export const contactUsIcon = () => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <svg
      fill="#BBA383"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 100 100"
    >
      <path
        d="M26.3,22.7c-4.5,0-8.2,3.5-8.2,7.8v44.3c0,4.3,3.7,7.8,8.2,7.8h43.6c4.5,0,8.2-3.5,8.2-7.8V30.5
	c0-4.3-3.7-7.8-8.2-7.8H26.3z M37.2,40.9c0,1.4-1.2,2.6-2.7,2.6h-2.7c-1.5,0-2.7-1.2-2.7-2.6v-2.6c0-1.4,1.2-2.6,2.7-2.6h2.7
	c1.5,0,2.7,1.2,2.7,2.6V40.9z M67.2,40.9c0,1.4-1.2,2.6-2.7,2.6H45.4c-1.5,0-2.7-1.2-2.7-2.6v-2.6c0-1.4,1.2-2.6,2.7-2.6h19.1
	c1.5,0,2.7,1.2,2.7,2.6V40.9z M37.2,54c0,1.4-1.2,2.6-2.7,2.6h-2.7c-1.5,0-2.7-1.2-2.7-2.6v-2.6c0-1.4,1.2-2.6,2.7-2.6h2.7
	c1.5,0,2.7,1.2,2.7,2.6V54z M62.2,54c0,1.4-1.2,2.6-2.7,2.6H45.4c-1.5,0-2.7-1.2-2.7-2.6v-2.6c0-1.4,1.2-2.6,2.7-2.6h14.1
	c1.5,0,2.7,1.2,2.7,2.6V54z M37.2,67c0,1.4-1.2,2.6-2.7,2.6h-2.7c-1.5,0-2.7-1.2-2.7-2.6v-2.6c0-1.4,1.2-2.6,2.7-2.6h2.7
	c1.5,0,2.7,1.2,2.7,2.6V67z M67.2,67c0,1.4-1.2,2.6-2.7,2.6H45.4c-1.5,0-2.7-1.2-2.7-2.6v-2.6c0-1.4,1.2-2.6,2.7-2.6h19.1
	c1.5,0,2.7,1.2,2.7,2.6V67z"
        fill="BBA383"
      />
    </svg>
  </div>
);
